import React, { useState } from 'react';
import './ContactModal.css';
import emailjs from '@emailjs/browser';
import { useLanguage } from '../contexts/LanguageContext';

const ContactModal = ({ isOpen, onClose }) => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    // Form verilerini console'da göster
    console.log('Form Data:', {
      name: `${formData.firstName} ${formData.lastName}`,
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      message: formData.message
    });

    // Geçici test - 2 saniye bekleyip başarılı göster
    setTimeout(() => {
      setSubmitStatus('success');
      setFormData({ firstName: '', lastName: '', email: '', message: '' });
      setIsSubmitting(false);
      setTimeout(() => {
        onClose();
        setSubmitStatus('');
      }, 2000);
    }, 2000);


    try {
      const serviceID = 'service_j4zys8o';
      const templateID = 'template_as3qen7';
      const publicKey = 'Aip68pmZSBeGyvGA6';

      const templateParams = {
        name: `${formData.firstName} ${formData.lastName}`,
        from_name: `${formData.firstName} ${formData.lastName}`,
        first_name: formData.firstName,
        last_name: formData.lastName,
        from_email: formData.email,
        message: `${formData.message}\n\n---\nGönderen: ${formData.firstName} ${formData.lastName}\nEmail: ${formData.email}`,
        to_email: 'info@phitech.ai',
        reply_to: formData.email
      };

      await emailjs.send(serviceID, templateID, templateParams, publicKey);
      setSubmitStatus('success');
      setFormData({ firstName: '', lastName: '', email: '', message: '' });
      setTimeout(() => {
        onClose();
        setSubmitStatus('');
      }, 2000);
    } catch (error) {
      console.error('Email send error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }

  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="contact-form-container">
          <h2 className="contact-title">{t('contactModal.title')}</h2>
          <p className="contact-description">
            {t('contactModal.description')}
          </p>
          
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">{t('contactModal.firstName')}</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder={t('contactModal.placeholder')}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">{t('contactModal.lastName')}</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder={t('contactModal.placeholder')}
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="email">{t('contactModal.email')}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t('contactModal.placeholder')}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">{t('contactModal.message')}</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder={t('contactModal.placeholder')}
                rows="4"
                required
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? t('contactModal.sending') : t('contactModal.submit')} →
            </button>
            
            {submitStatus === 'success' && (
              <div className="status-message success">{t('contactModal.success')}</div>
            )}
            {submitStatus === 'error' && (
              <div className="status-message error">{t('contactModal.error')}</div>
            )}
          </form>
          
          <div className="contact-info">
            <p>info@phitech.ai</p>
            <div className="social-icons">
              <a 
                href="https://www.linkedin.com/company/phitechai/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="linkedin-link"
              >
                <img src="/images/Social icon.png" alt="LinkedIn" className="social-icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;